export default {"src":"/_next/static/media/support_white.15e063ec.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};